import Vue from 'vue';
import moment from 'moment';
import { decode as JWTdecode } from 'jsonwebtoken';

const LOGIN = 'LOGIN';
const LOGOUT = 'LOGOUT';
const INJECT_AXIOS_INTERCEPTOR = 'INJECT_AXIOS_INTERCEPTOR';
const REJECT_AXIOS_INTERCEPTOR = 'REJECT_AXIOS_INTERCEPTOR';

const isLoggedIn = ({ token, expiresAt }) => (
  token !== null && expiresAt !== null && moment().isBefore(expiresAt)
);

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem('token') || null,
    expiresAt: localStorage.getItem('tokenExpired') || null,
    axiosInterceptorId: null,
  },
  mutations: {
    /* eslint-disable no-param-reassign */
    [LOGIN](state, { token }) {
      state.token = token;
      state.expiresAt = moment(JWTdecode(token).exp * 1000);

      localStorage.setItem('token', state.token);
      localStorage.setItem('tokenExpired', state.expiresAt);
    },
    [INJECT_AXIOS_INTERCEPTOR](state) {
      if (isLoggedIn(state)) {
        state.axiosInterceptorId = Vue.axios.interceptors.request.use((config) => {
          config.headers.authorization = `Bearer ${state.token}`;

          return config;
        });
      }
    },
    [LOGOUT](state) {
      state.token = null;
      state.expiresAt = null;

      localStorage.removeItem('token');
      localStorage.removeItem('tokenExpired');
    },
    [REJECT_AXIOS_INTERCEPTOR](state) {
      Vue.axios.interceptors.request.eject(state.axiosInterceptorId);
      state.axiosInterceptorId = null;
    },
    /* eslint-enable no-param-reassign */
  },
  actions: {
    injectAxiosInterceptor({ commit }) {
      commit(INJECT_AXIOS_INTERCEPTOR);
    },
    login({ commit }, { email, password }) {
      return Vue.axios.post('auth/login', {
        email,
        password,
      })
        .then(({ data }) => {
          commit(LOGIN, data);
          commit(INJECT_AXIOS_INTERCEPTOR);
        });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit(LOGOUT);
        commit(REJECT_AXIOS_INTERCEPTOR);
        resolve();
      });
    },
  },
  getters: {
    isLoggedIn,
    token: state => state.token,
    expiresAt: state => state.expiresAt,
  },
};
